function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.625 4.96875H8.375C7.82344 4.96875 7.375 5.41719 7.375 5.96875V17.9688C7.375 18.5203 7.82344 18.9688 8.375 18.9688H15.625C16.1766 18.9688 16.625 18.5203 16.625 17.9688V5.96875C16.625 5.41719 16.1766 4.96875 15.625 4.96875ZM15.5 17.8438H8.5V6.09375H15.5V17.8438ZM11.375 16.25C11.375 16.4158 11.4408 16.5747 11.5581 16.6919C11.6753 16.8092 11.8342 16.875 12 16.875C12.1658 16.875 12.3247 16.8092 12.4419 16.6919C12.5592 16.5747 12.625 16.4158 12.625 16.25C12.625 16.0842 12.5592 15.9253 12.4419 15.8081C12.3247 15.6908 12.1658 15.625 12 15.625C11.8342 15.625 11.6753 15.6908 11.5581 15.8081C11.4408 15.9253 11.375 16.0842 11.375 16.25Z",
  fill: "#404047"
});

var SvgContactPreferences = function SvgContactPreferences(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactPreferences, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-preferences.d4d7c74f.svg";
export { ForwardRef as ReactComponent };